import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Expense Accounts processing and wallets: AccessProvisioning.expenseAccounts only.
// UI only - every Accounts API re-checks the permission in the database.
const ExpenseAccountsRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user || user.access === undefined) return <div>Loading...</div>;
  return user.access?.expenseAccounts === true
    ? children
    : <Navigate to={user.primaryRole === 'admin' ? '/admin/dashboard' : '/dashboard'} replace />;
};

export default ExpenseAccountsRoute;
